import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import NoticeBar from './components/NoticeBar';
import { initAnalytics } from './lib/funnel';

initAnalytics(); // GA4 stays denied until consent (see lib/preferences.ts)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
    <NoticeBar />
  </React.StrictMode>
);
